import DefaultValue from "./default-value";
import { NONE_UNIFORM } from "../../../common/players/NoPlayer";
import FootballState from "../../state/football-state";

export default class OOBTacklerDefaultValue extends DefaultValue {
    constructor(play, fragment, summaryContext, team) {
        super(play, fragment, summaryContext, team);
    }

    resolve() {
        const { associatedState } =
            this.play.getPreviousFragment(this.fragment) || {};
        const naPlayer = this.team?.players?.find(
            (p) => p.uniform === NONE_UNIFORM
        );

        return associatedState === FootballState.KickOff && naPlayer
            ? [naPlayer]
            : super.resolve();
    }
}
